/* eslint-disable eqeqeq */
import { Button, Popover } from 'antd';
import EditIcon from '../../../common/icons/EditIcon';
import countWords from '../../../utils/countWords';
import trimWords from '../../../utils/trimWords';
import { ReadOutlined } from '@ant-design/icons';

const installmentsTableColumns = (
  allFetchedInstallments,
  setModalOpened,
  setFetchCount,
  setSelectedIntallment,
  setIsLoading,
  token
) => {
  const handleEditClick = (record) => {
    const found = allFetchedInstallments.find((obj) => obj.id === record.id);
    if (found) {
      setSelectedIntallment({ ...found });
      setModalOpened(true);
    }
  };

  const renderActions = (obj) => {
    return (
      <div className="action-btns-wrap">
        <div className="edit-btn" onClick={() => handleEditClick(obj)}>
          <EditIcon />
          تعديل
        </div>
        {/* <Popconfirm
          title="هل أنت متأكد من الحذف"
          onConfirm={() => handleDeleteRequest(obj.id)}
          okText="نعم"
          cancelText="لا"
        >
          <Tooltip title="الحذف">
            <div className="delete-btn">
              <DeleteIcon />
            </div>
          </Tooltip>
        </Popconfirm> */}
      </div>
    );
  };

  // const handleDeleteRequest = async (id) => {
  //   try {
  //     setIsLoading(true);
  //     const res = await deleteInstallmentApi(token, id);
  //     if (res?.status === 200 && res?.data?.status === 1) {
  //       setIsLoading(false);
  //       setFetchCount((prevState) => prevState + 1);
  //       successNotification({
  //         title: 'العملية تمت بنجاح',
  //         message: 'تم حذف الايصال بنجاح'
  //       });
  //     } else {
  //       setIsLoading(false);
  //       errorNotification({
  //         title: 'حدث خطأ اثناء العملية',
  //         message: res?.data?.message
  //           ? res.data.message
  //           : 'من فضلك حاول فى وقت لاحق'
  //       });
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //     errorNotification({
  //       title: 'حدث خطأ',
  //       message: 'حاول فى وقت لاحق'
  //     });
  //   }
  // };

  return [
    {
      title: 'كود الايصال',
      dataIndex: 'id',
      // width: 62
      render: (_, record) => {
        return (
          <div className="row-cell row-index bold-font">
            <span># {record.id}</span>
          </div>
        );
      }
    },
    {
      title: 'تاريخ الاستحقاق',
      dataIndex: 'date',
      render: (_, record) => {
        return (
          <div className="row-cell row-text">
            {record?.date ? record.date : '----'}
          </div>
        );
      }
    },
    {
      title: 'الحالة',
      dataIndex: 'status',
      render: (_, record) => {
        return (
          <div className="row-cell row-text">
            {record?.status
              ? record.status == 1
                ? 'تم الدفع'
                : 'لم يتم الدفع'
              : '----'}
          </div>
        );
      }
    },

    {
      title: 'ملاحظات',
      dataIndex: 'note',
      render: (_, record) => {
        if (record.note) {
          const wordsCount = countWords(String(record.note));
          if (wordsCount > 3) {
            return (
              <Popover title="اقرأ المزيد" content={String(record.note)}>
                <Button size="large" type="text">
                  <p className="has-read-more">
                    <span>{trimWords(String(record.note), 4)}</span>
                    <ReadOutlined
                      className="read-more-book"
                      style={{ margin: '0 4px' }}
                    />
                  </p>
                </Button>
              </Popover>
            );
          } else
            return (
              <div className="row-cell row-text">{String(record.note)}</div>
            );
        } else {
          return '----';
        }
      }
    },

    {
      title: 'السعر',
      dataIndex: 'price',
      render: (_, record) => {
        return (
          <div className="row-cell row-text">
            {record?.price ? record.price : '----'}
          </div>
        );
      }
    },
    {
      title: 'الاعدادات',
      dataIndex: 'actions',
      render: (_, record) => {
        return (
          <div className="row-cell row-actions">{renderActions(record)}</div>
        );
      }
    }
  ];
};

export default installmentsTableColumns;
